import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ButtonStandard, ButtonStandardType } from 'record-it-components/button/ButtonStandard/ButtonStandard';
import { CardListItem, CardListItemSize } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useRequiredWorkTimeEntryToCreate } from '../../../hooks/createWorkTimeEntry/useRequiredWorkTimeEntryToCreate';
import { useEntityByIdOrOriginalId } from '../../../hooks/entity/useEntityByIdOrOriginalId';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import styles from './WorkTimeEntryToCreateConstructionSiteWidget.module.css';
export type WorkTimeEntryToCreateConstructionSiteWidgetProps = PropsWithoutChildren<ComponentProps<'div'>>;
export const WorkTimeEntryToCreateConstructionSiteWidget: FunctionComponent<WorkTimeEntryToCreateConstructionSiteWidgetProps> = React.memo(props => {
  const $ = _c(28);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  if ($[2] !== t0) {
    ({
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
  } else {
    remainingProps = $[3];
  }
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    t
  } = useTranslation();
  const workTimeEntryToCreate = useRequiredWorkTimeEntryToCreate();
  const selectedConstructionSite = useEntityByIdOrOriginalId(EntityName.ConstructionSite, workTimeEntryToCreate.constructionSiteId);
  let t1;
  if ($[4] !== dispatch) {
    t1 = () => {
      dispatch(createWorkTimeEntrySlice.actions.setConstructionSiteId(null));
    };
    $[4] = dispatch;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleRemoveSelectedConstructionSiteClick = useEventCallback(t1);
  let t2;
  if ($[6] !== navigate) {
    t2 = () => {
      navigate(RoutePaths.createWorkTimeEntrySelectConstructionSite());
    };
    $[6] = navigate;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleSelectConstructionSiteClick = useEventCallback(t2);
  let t3;
  if ($[8] !== t) {
    t3 = t("components.workTime.WorkTimeEntryToCreateConstructionSiteWidget.title");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <div className={styles.title}>{t3}</div>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleRemoveSelectedConstructionSiteClick || $[13] !== selectedConstructionSite || $[14] !== t || $[15] !== workTimeEntryToCreate.constructionSiteId) {
    t5 = workTimeEntryToCreate.constructionSiteId ? <CardListItem size={CardListItemSize.Small} inline={true} data-testid="WorkTimeEntryBreakListItem.SelectedConstructionSite"><CardListItemTitle>{selectedConstructionSite ? selectedConstructionSite.name : t("components.workTime.WorkTimeEntryToCreateConstructionSiteWidget.unknownConstructionSite")}</CardListItemTitle><CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleRemoveSelectedConstructionSiteClick} data-testid="WorkTimeEntryToCreateConstructionSiteWidget.RemoveSelectedConstructionSite" /></CardListItem> : null;
    $[12] = handleRemoveSelectedConstructionSiteClick;
    $[13] = selectedConstructionSite;
    $[14] = t;
    $[15] = workTimeEntryToCreate.constructionSiteId;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = workTimeEntryToCreate.constructionSiteId ? "constructionSiteAlreadySelected" : null;
  let t7;
  if ($[17] !== t || $[18] !== t6) {
    t7 = t("components.workTime.WorkTimeEntryToCreateConstructionSiteWidget.selectConstructionSite", {
      context: t6
    });
    $[17] = t;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== handleSelectConstructionSiteClick || $[21] !== t7) {
    t8 = <div className={styles.selectConstructionSiteButtonWrapper}><ButtonStandard type={ButtonStandardType.Primary} onClick={handleSelectConstructionSiteClick} data-testid="WorkTimeEntryToCreateConstructionSiteWidget.SelectConstructionSiteButton">{t7}</ButtonStandard></div>;
    $[20] = handleSelectConstructionSiteClick;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== remainingProps || $[24] !== t4 || $[25] !== t5 || $[26] !== t8) {
    t9 = <div {...remainingProps}>{t4}{t5}{t8}</div>;
    $[23] = remainingProps;
    $[24] = t4;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
});